module.exports = __webpack_public_path__ + "images/close06bcd86c3e5449ff6119880dd16b05c2.svg";